import { axios } from "~/plugins/request"
export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  initOrderList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/onlineOrder/findOnlineOrderList', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOrderDetailById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/onlineOrder/findOnlineOrderById', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  exportOrder({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/onlineOrder/exportOnlineOrder',
        data: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  refundOrder({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/onlineOrder/refundDepositPrice', params).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
}